import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AuthProvider } from './auth'
import { ThemeModeProvider } from './components/ThemeModeContext'
import App from './App.tsx'
import './index.css'
import { initAnalytics } from './services/analytics'
import { initGoogleAnalytics } from './services/googleAnalytics'

// Initialize i18n
import './i18n'

// Initialize analytics (each provider has its own feature flag)
initAnalytics()
initGoogleAnalytics()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <ThemeModeProvider>
        <App />
      </ThemeModeProvider>
    </AuthProvider>
  </StrictMode>,
)
